import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "notification-drawer__header-inner" }
const _hoisted_2 = { class: "notification-drawer__header-left" }
const _hoisted_3 = { class: "notification-drawer__list" }
const _hoisted_4 = {
  key: 0,
  class: "notification-drawer__loading-more"
}

import { watchEffect, watch, onUnmounted, ref, nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import Drawer from 'primevue/drawer';
import NotificationEntry from '@/components/notifications/NotificationEntry.vue';
import { useNotificationsStore } from '@/stores/notifications';


export default /*@__PURE__*/_defineComponent({
  __name: 'NotificationDrawer',
  setup(__props) {

/* eslint-env vue/setup-compiler-macros */
const notificationsStore = useNotificationsStore();
const {
    notifications,
    isDrawerOpen,
    isLoading,
    isLoadingMore,
    hasMore,
} = storeToRefs(notificationsStore);
const {
    closeDrawer,
    markAllAsRead,
    loadMore,
} = notificationsStore;

const scrollContainer = ref<HTMLElement | null>(null);
const sentinel = ref<HTMLElement | null>(null);
let observer: IntersectionObserver | null = null;

watchEffect(() => {
    document.body.style.overflow = isDrawerOpen.value ? 'hidden' : '';
});

watch(isDrawerOpen, async (open) => {
    if (open && !observer) {
        await nextTick();
        if (sentinel.value && scrollContainer.value) {
            observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting && !isLoading.value && !isLoadingMore.value && hasMore.value) {
                        loadMore();
                    }
                },
                { root: scrollContainer.value, threshold: 0 },
            );
            observer.observe(sentinel.value);
        }
    }
});

onUnmounted(() => {
    document.body.style.overflow = '';
    observer?.disconnect();
    observer = null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Drawer), {
    visible: _unref(isDrawerOpen),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isDrawerOpen) ? (isDrawerOpen).value = $event : null)),
    position: "right",
    showCloseIcon: false,
    pt: {
            root: { class: 'notification-drawer' },
            mask: { class: 'notification-drawer-mask' },
            content: { class: 'notification-drawer__content' },
            header: { class: 'notification-drawer__header' },
        }
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[3] || (_cache[3] = _createElementVNode("h2", { class: "notification-drawer__title" }, "Notifications", -1)),
          _createElementVNode("button", {
            class: "notification-drawer__mark-read",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(markAllAsRead) && _unref(markAllAsRead)(...args)))
          }, " Mark All as Read ")
        ]),
        _createElementVNode("button", {
          class: "notification-drawer__close",
          type: "button",
          "aria-label": "Close notifications",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(closeDrawer) && _unref(closeDrawer)(...args)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("i", {
            class: "pi pi-times",
            "aria-hidden": "true"
          }, null, -1)
        ]))])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "scrollContainer",
        ref: scrollContainer,
        class: "notification-drawer__scroll"
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(notifications), (item) => {
            return (_openBlock(), _createBlock(NotificationEntry, {
              key: item.id,
              message: item.message,
              "bold-segments": item.boldSegments,
              "created-at": item.createdAt,
              "is-read": item.isRead,
              href: item.href,
              onClick: ($event: any) => (_unref(notificationsStore).handleNotificationClick(item.id))
            }, null, 8, ["message", "bold-segments", "created-at", "is-read", "href", "onClick"]))
          }), 128))
        ]),
        (_unref(isLoadingMore))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", {
                class: "pi pi-spin pi-spinner",
                "aria-hidden": "true"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          ref_key: "sentinel",
          ref: sentinel,
          class: "notification-drawer__sentinel"
        }, null, 512)
      ], 512)
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})